import { Dialog, Card } from '@mui/material';
import { icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import { useIsMobile } from '../../helpers/customHooks';
import NewButton from '../Buttons/NewButton';

const DeleteEvents = ({ onClose, deleteAll, show }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();

    const handleClose = () => {
        onClose()
      //  setShow(false)
    }
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                <div className="w-100 h-100">

                    <div className="p-3">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className='d-flex align-items-center'>
                                <h3 className="">{t("events.delete_all_events_title")}</h3>
                            </div>
                            <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." />
                        </div>
                        <p className="grey-blue py-3">{t("events.delete_all_events_body")}</p>
                        <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                            <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("events.cancel")}</NewButton>
                            <NewButton onClick={() => deleteAll()} className="bg-red p-3 rounded24 w-100 white ms-2 body bold">{t("events.delete_alarms")}</NewButton>
                        </div>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default DeleteEvents;